<div class="mini-footer-container {{vars.pageName()}}">
    <div class="content">
        <span class="title">
            Copyright © {{currentYear}} {{vars.domainData().name}}. All Rights Reserved.
        </span>
        <div class="policy-links">
          <span><a href="https://app.termageddon.com/api/policy/VmtOVlMwbFFhRWd6VTFKM2VtYzlQUT09?h-align=left&table-style=accordion" target="_blank">Terms of Service</a></span>
          <span><a href="https://app.termageddon.com/api/policy/VVZWTE0zUm1UWEZyUkdkelluYzlQUT09?h-align=left&table-style=accordion" target="_blank">Privacy Policy</a></span>
          <span><a routerLink="/donorprotectionpolicy">{{vars.domainData().name}} Donor Protection Policy </a></span>
        </div>
        <span class="desc">
            {{vars.domainData().name}} ({{vars.defaultOrganiserName}}) is a California-registered 501(c)(3) nonprofit
            organization (EIN 93-3691588).
        </span>
    </div>
</div>